import React, { useState, useEffect } from "react";
import _ from "lodash";
import History from "../components/Steps/History";
import Step1 from "../components/Steps/Step1";
import Step2 from "../components/Steps/Step2";
import Step3 from "../components/Steps/Step3";
import Step4 from "../components/Steps/Step4";
import Step5 from "../components/Steps/Step5";
import Step6 from "../components/Steps/Step6";
import { Form, Spin } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import $axios from "../services/axios";
import showCustomNotification from "../components/Common/showCustomNotification";
import moment from "moment";

const Home = () => {
  const [form] = Form.useForm();
  const [listFlight, setListFlight] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tripType, setTripType] = useState("oneWay");
  const [chooseFlight, setChooseFlight] = useState([]);
  const [airports, setAirports] = useState([]);
  const [airlines, setAirlines] = useState([]);
  const [airportInfo, setAirportInfo] = useState([]);
  const [airlineInfo, setAirlineInfo] = useState([]);
  const [isPromotionOrSameDayTicket, setIsPromotionOrSameDayTicket] =
    useState(false);
  const [arrival, setArrival] = useState([]);
  const [step, setStep] = useState(1);
  const [statusPayment, setStatusPayment] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [bookingInfo, setBookingInfo] = useState({});
  const [filterDay, setFilterDay] = useState("");
  const [filterDayReturn, setFilterDayReturn] = useState("");
  const [loadingSearchFlight, setLoadingSearchFlight] = useState(false);
  const [loadingAirPorts, setLoadingAirPorts] = useState(true);
  const [ChoosingStep, setChoosingStep] = useState(1);

  const location = useLocation();
  const history = useHistory();
  // http://127.0.0.1:3000/vemaybay?amount=6968980&message=&payment_type=SaigonBank&reference_number=ABT2025&status=1&trans_ref_no=3527055&website_id=199760&signature=404B658191309354C4ED3B12E2529E533C7CDE5C03FFE2FD3204B9BDBF643E0C

  useEffect(() => {
    hanleProcessPaymentReturn();
  }, [location, history]);

  const handleBookingInfo = (booking) => {
    setBookingInfo(booking);
  };

  const hanleProcessPaymentReturn = async () => {
    const queryParams = new URLSearchParams(location.search);
    const amount = queryParams.get("amount");
    const payment_type = queryParams.get("payment_type");
    const reference_number = queryParams.get("reference_number");
    const status = queryParams.get("status");
    const trans_ref_no = queryParams.get("trans_ref_no");
    const website_id = queryParams.get("website_id");
    const signature = queryParams.get("signature");

    if (
      amount &&
      payment_type &&
      reference_number &&
      status &&
      trans_ref_no &&
      website_id &&
      signature &&
      bookingInfo
    ) {
      if (status === "1") {
        setStatusPayment(true);
        setOrderId(reference_number);
      } else {
        setStatusPayment(false);
      }
      setTimeout(() => {
        setStep(6);
      }, 0);
    }
  };

  useEffect(() => {
    filterDay && fetchSearchFlight(form.getFieldValue());
  }, [filterDay, filterDayReturn]);

  const fetchSearchFlight = async (values) => {
    setLoadingSearchFlight(true);
    try {
      const response = await $axios.$post(`flights/searchflight`, {
        Adt: values.Adt,
        Chd: values.Chd,
        Inf: values.Inf,
        token: localStorage.getItem("verifyToken"),
        ListFlight:
          tripType === "oneWay"
            ? [
                {
                  Airline: "",
                  StartPoint: values.StartPoint,
                  EndPoint: values.EndPoint,
                  DepartDate: filterDay,
                },
              ]
            : [
                {
                  Airline: "",
                  StartPoint: values.StartPoint,
                  EndPoint: values.EndPoint,
                  DepartDate: filterDay,
                },
                {
                  Airline: "",
                  StartPoint: values.EndPoint,
                  EndPoint: values.StartPoint,
                  DepartDate: filterDayReturn,
                },
              ],
      });
      setListFlight(
        response.data.ListFareData.map((item) => ({
          ...item,
          FlightType: response.data.FlightType,
          Session: response.data.Session,
        }))
      );
      setLoadingSearchFlight(false);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  const getAirPorts = async () => {
    try {
      setLoadingAirPorts(true);
      const response = await $axios.$get(`airports`);
      setAirports(response.data);
      setLoadingAirPorts(false);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  const getAirLines = async () => {
    try {
      const response = await $axios.$get(`airlines`);
      setAirlines(response.data);
    } catch (error) {
      showCustomNotification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  useEffect(() => {
    getAirPorts();
    getAirLines();
  }, []);

  useEffect(() => {
    if (arrival.length > 0) {
      setAirportInfo(_.filter(airports, (air) => arrival.includes(air.code)));
    }
  }, [arrival, airports]);

  useEffect(() => {
    if (chooseFlight.length > 0) {
      const isSameDayTicket = _.some(chooseFlight, (f) => {
        const startDate = moment(f.ListFlight[0].StartDate);
        const now = moment();
        return startDate.isBefore(now.add(24, "hours"));
      });
      let isPromo = true;
      _.forEach(chooseFlight, (f) => {
        // check vé khuyến mãi
        if (!f.Promo) {
          isPromo = false;
        }
      });
      setIsPromotionOrSameDayTicket(isPromo || isSameDayTicket);
      setAirlineInfo(
        _.filter(airlines, (air) =>
          _.some(chooseFlight, (f) => f.Airline === air.code)
        )
      );
    }
  }, [chooseFlight, airlines]);

  const handleBackButton = () => {
    setStep(1);
    setFilterDayReturn("");
    setFilterDay("");
  };

  return (
    <div className="home">
      <Spin
        tip={
          <div>
            <div className="text-[16px]">Yêu cầu đặt vé đang xử lý</div>
            <div className="text-[16px]">
              Xin quý khách vui lòng đợi trong giây lát...
            </div>
          </div>
        }
        size="large"
        spinning={loading}
      >
        {step === 0 && <History airports={airports} onChangeStep={setStep} />}
        {step === 1 && (
          <Step1
            onChangeStep={setStep}
            tripType={tripType}
            setTripType={setTripType}
            setAirport={setArrival}
            airport={arrival}
            airports={airports}
            chooseFlight={chooseFlight}
            setChooseFlight={setChooseFlight}
            setFilterDay={setFilterDay}
            setFilterDayReturn={setFilterDayReturn}
            loadingAirPorts={loadingAirPorts}
            form={form}
          />
        )}
        {step === 2 && (
          <Step2
            onChangeStep={setStep}
            listFilght={listFlight}
            chooseFlight={chooseFlight}
            setChooseFlight={setChooseFlight}
            tripType={tripType}
            airport={arrival}
            airports={airports}
            setStep={setStep}
            filterDay={filterDay}
            setFilterDay={setFilterDay}
            filterDayReturn={filterDayReturn}
            setFilterDayReturn={setFilterDayReturn}
            loadingSearchFlight={loadingSearchFlight}
            ChoosingStep={ChoosingStep}
            setChoosingStep={setChoosingStep}
            onBackButton={handleBackButton}
          />
        )}
        {step === 3 && (
          <Step3
            onChangeStep={setStep}
            isPromotionOrSameDayTicket={isPromotionOrSameDayTicket}
            tripType={tripType}
            airportInfo={airportInfo}
            chooseFlight={chooseFlight}
            setLoading={setLoading}
            onChangeBookingInfo={(e) => {
              handleBookingInfo(e);
            }}
            setStep={setStep}
          />
        )}
        {step === 4 && (
          <Step4
            airlineInfo={airlineInfo}
            airportInfo={airportInfo}
            onChangeStep={setStep}
            isPromotionOrSameDayTicket={isPromotionOrSameDayTicket}
            bookingInfo={bookingInfo}
            chooseFlight={chooseFlight}
          />
        )}
        {step === 5 && (
          <Step5
            airlineInfo={airlineInfo}
            airportInfo={airportInfo}
            onChangeStep={setStep}
            isPromotionOrSameDayTicket={isPromotionOrSameDayTicket}
            bookingInfo={bookingInfo}
            chooseFlight={chooseFlight}
            airports={airports}
          />
        )}
        {step === 6 && (
          <Step6
            setLoading={setLoading}
            orderId={orderId}
            statusPayment={statusPayment}
            onChangeStep={setStep}
          />
        )}
      </Spin>
      {/* <div className="flex bg-white h-[81px] w-full px-[24px] py-3 fixed bottom-0 justify-between items-center">
        <div className="flex flex-col items-center">
          <img className="w-[28px]" src={"../images/ve-may-bay.svg"} alt="" />
          <a
            href="/ve-may-bay"
            className="text-[#22313F] text-[14px] font-medium"
          >
            Vé máy bay
          </a>
        </div>
        <div className="flex flex-col items-center">
          <img className="w-[28px]" src={"../images/khach-san.svg"} alt="" />
          <span className="text-[#808080CC] text-[14px] font-medium">
            Khách sạn
          </span>
        </div>
        <div className="flex flex-col items-center">
          <img className="w-[28px]" src={"../images/ve-tau.svg"} alt="" />
          <span className="text-[#808080CC] text-[14px] font-medium">
            Vé tàu
          </span>
        </div>
        <div className="flex flex-col items-center">
          <img className="w-[28px]" src={"../images/ve-xe.svg"} alt="" />
          <span className="text-[#808080CC] text-[14px] font-medium">
            Vé xe
          </span>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
